import { render, staticRenderFns } from "./SentMails.vue?vue&type=template&id=44db133a&scoped=true&"
import script from "./SentMails.vue?vue&type=script&lang=js&"
export * from "./SentMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db133a",
  null
  
)

export default component.exports